import React, { useContext } from "react";
import {
  List,
  Button,
  Typography,
  Tooltip,
  Popconfirm,
  Badge,
  notification,
  Skeleton,
  message,
  Empty,
} from "antd";

import { Persona, PersonaSize } from "@fluentui/react/lib/Persona";

import { toJS } from "mobx";
import { inject, observer } from "mobx-react";

import PermissionStore from "../store/permissionStore";

import * as mobx from "mobx";
import {
  TeamOutlined,
  UsergroupAddOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
const { Title, Text } = Typography;

export const RoleUser = observer((props) => {
  const permissionStore = useContext(PermissionStore);

  return (
    <>
      {!permissionStore.isLoadingUsersInRole ? (
        <div
          className="ms-Grid"
          dir="ltr"
          style={{
            borderRight: "1px solid #F0F2F5",
            height: "100vh",
          }}
        >
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm12"
              style={{ paddingBottom: "10px" }}
            >
              <List
                itemLayout="horizontal"
                size="small"
                locale={{
                  emptyText: (
                    <Empty
                      description={`No User is found in this ${permissionStore?.selectedRole?.name} group,click add users to the account group`}
                    />
                  ),
                }}
                dataSource={[...permissionStore.usersInRole.values()]}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm9">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "13px",
                            color: "red",
                          }}
                        >
                          <TeamOutlined style={{ color: "#FAAD14" }} />{" "}
                          {permissionStore.selectedRole?.name
                            ? permissionStore.selectedRole?.name
                            : ""}
                        </Title>
                        <Badge
                          count={permissionStore.usersInRole.size}
                          title={`${permissionStore.usersInRole.size} users`}
                        />
                      </div>
                      <div
                        className="ms-Grid-col ms-sm3"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip
                          title={`add users to  ${permissionStore?.selectedRole?.name} account group`}
                        >
                          <Button
                            shape="circle"
                            icon={<UsergroupAddOutlined />}
                            type="primary"
                            onClick={(ev) => {
                              if (!permissionStore?.selectedRole) {
                                notification["info"]({
                                  message: "Workflow Manager",
                                  description:
                                    "please select a account group to add users",
                                });
                                return;
                              }
                              permissionStore.showAddUserToRoleDialog = true;
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Tooltip title="remove user  from account group">
                        <Popconfirm
                          title={`Confirm removal of ${item.fullName} `}
                          onConfirm={async () => {
                            try {
                              const { id: userId } = item;
                              const roleId =
                                permissionStore?.selectedRole?.groupId;
                              await permissionStore.removeUserFromRole(
                                userId,
                                roleId
                              );

                              message.success(
                                `${item.fullName} was successfully removed from ${permissionStore?.selectedRole?.name}s `
                              );
                            } catch (error) {
                              notification.error({
                                message: "Feedback Manager",
                                description: `something went wrong due to ${error.message}`,
                              });
                            }
                          }}
                        >
                          <Button
                            icon={<UserDeleteOutlined />}
                            type="link"
                            style={{ fontSize: "18px" }}
                          />
                        </Popconfirm>
                      </Tooltip>,
                    ]}
                  >
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        <Persona
                          text={`${item.fullName} `}
                          size={PersonaSize.size24}
                          secondaryText={item.jobFunction}
                          showSecondaryText={true}
                        />
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      )}
    </>
  );
});

